<template>
  <div>
    <h3 class="text-black mb-4">QR Code</h3>
    <!-- FILTER START -->
    <panel :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row">
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <label for="searchBy">Search By</label>
          <div class="input-group mt-1">
            <div class="input-group-prepend" style="height: 43px">
              <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ filterOptChosen.text }}&nbsp;
                <i class="fas fa-caret-down"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" v-for="opt in filterOpt" @click="filterOptChosen = opt">{{ opt.text }}</a>
              </div>
            </div>
            <input v-model="searchFilter.keyword" type="text" class="form-control" aria-label="Text input with dropdown button" style="height: 43px" />
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <label for="partshopCode">Status</label>
          <MultiSelect v-model="searchFilter.status" class="mt-1" :options="['ACTIVE', 'INACTIVE']" :multiple="false" :allow-empty="true" placeholder="All Status"></MultiSelect>
        </div>
        <div class="row justify-content-end px-2 py-3">
          <div class="col-md-3" style="display: flex; flex-direction: column-reverse; padding-top: 20px">
            <button class="btn button-new-2 d-flex align-items-center justify-content-center" type="button" @click="showExcelModal = true" style="height: 38px; margin-bottom: 0.5%">
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.99935 8.66675L2.66602 5.33342L3.59935 4.36675L5.33268 6.10008V0.666748H6.66602V6.10008L8.39935 4.36675L9.33268 5.33342L5.99935 8.66675ZM1.99935 11.3334C1.63268 11.3334 1.3189 11.203 1.05802 10.9421C0.797127 10.6812 0.66646 10.3672 0.666016 10.0001V8.00008H1.99935V10.0001H9.99935V8.00008H11.3327V10.0001C11.3327 10.3667 11.2022 10.6807 10.9413 10.9421C10.6805 11.2034 10.3665 11.3339 9.99935 11.3334H1.99935Z" fill="#F36F21" />
              </svg>

              <span class="ml-2">Export To Excel</span>
            </button>
          </div>
          <div class="col-md-3" style="display: flex; flex-direction: column-reverse; padding-top: 20px">
            <button class="btn button-new-1" type="button" style="height: 38px; margin-bottom: 0.5%" @click="applySearch">Search</button>
          </div>
        </div>
      </div>
    </panel>
    <!-- FILTER END -->

    <template v-if="!filter">
      <div class="bg-white py-4 radius-sm">
        <div class="vue_universal_table_table">
          <table class="table table-striped">
            <thead style="background-color: rgb(255, 255, 255)">
              <tr>
                <th class="tableTitle sortable text-center">QR Code</th>
                <th class="tableTitle sortable">Serial Number</th>
                <th class="tableTitle sortable">Engine Number</th>
                <th class="tableTitle sortable">Status</th>
                <th class="tableTitle sortable">Active Date</th>
                <th class="tableTitle sortable">Created At</th>
                <th colspan="1" style="text-align: center"><i class="fas fa-cog"></i></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img class="my-4" :src="require('@/assets/img/icon/no-filter.jpg')" alt="no-filter" />
          <p>Select and search filter to display data</p>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="bg-white py-4 radius-sm">
        <vue-universal-table-qrcode :api_url="'/api/reports/qr-code'" @dataLoaded="handleDataLoaded" :filter="filter" :fields="vue_universal_table_qrcode.fields" :buttons="vue_universal_table_qrcode.buttons" :update="vue_universal_table_qrcode.update" :infinite_scroll="true" @onDetails="showDetail" />
      </div>

      <!-- <div v-if="loading" class="text-center">
        <p>Loading...</p>
      </div>
      <template v-else-if="!isDataAvailable">
        <div class="bg-white py-4 radius-sm text-center">
          <p>Data is not available</p>
        </div>
      </template> -->
      <template v-if="!isDataAvailable">
        <div class="bg-white py-4 radius-sm text-center">
          <p>Data is not available</p>
        </div>
      </template>
    </template>

    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showModal = false">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <div class="modal-container" @click.stop>
                <div class="modal-header" style="justify-content: flex-end">
                  <button type="button" class="close" @click="showModal = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <h2 class="text-center">QR Code Details</h2>
                  <div class="row">
                    <div class="col-md-7 col-12">
                      <table class="table table-borderless">
                        <tbody class="border border-secondary shadow" style="border-radius: 5px !important">
                          <tr>
                            <td colspan="3" class="text-center"><h4>Vehicle Matched Details</h4></td>
                          </tr>
                          <tr>
                            <td>QR Code</td>
                            <td>:</td>
                            <td>{{ vehicleData.qrcode }}</td>
                          </tr>
                          <tr>
                            <td>Engine Number</td>
                            <td>:</td>
                            <td>{{ vehicleData.engine_no }}</td>
                          </tr>
                          <tr>
                            <td>Frame Number</td>
                            <td>:</td>
                            <td>{{ vehicleData.frame_no }}</td>
                          </tr>
                          <tr>
                            <td>Active Date</td>
                            <td>:</td>
                            <td>{{ vehicleData.active_date ? new moment(vehicleData.active_date).format("YYYY-MM-DD HH:mm:ss") : "" }}</td>
                          </tr>
                          <tr>
                            <td>Original Location</td>
                            <td>:</td>
                            <td>{{ vehicleData.ori_loc_code }}</td>
                          </tr>
                          <tr>
                            <td>Last Known Location</td>
                            <td>:</td>
                            <td>{{ vehicleData.current_loc_code }}</td>
                          </tr>
                          <tr>
                            <td>Activity Type</td>
                            <td>:</td>
                            <td>{{ vehicleData.current_activity }}</td>
                          </tr>
                        </tbody>
                        <br />
                        <tbody class="border border-secondary shadow" style="border-radius: 5px !important">
                          <tr>
                            <td colspan="3" class="text-center">
                              <h4>Vehicle Information</h4>
                            </td>
                          </tr>
                          <tr>
                            <td>Vehicle Type</td>
                            <td>:</td>
                            <td>{{ vehicleData.type_code }}</td>
                          </tr>
                          <tr>
                            <td>Commercial Name</td>
                            <td>:</td>
                            <td>{{ vehicleData.commercial_name }}</td>
                          </tr>
                          <tr>
                            <td>Segment</td>
                            <td>:</td>
                            <td>{{ vehicleData.segment }}</td>
                          </tr>
                          <tr>
                            <td>Series</td>
                            <td>:</td>
                            <td>{{ vehicleData.series }}</td>
                          </tr>
                          <tr>
                            <td>Colour</td>
                            <td>:</td>
                            <td>{{ vehicleData.color }} - {{ vehicleData.colorDescription }}</td>
                          </tr>
                          <tr>
                            <td>Manufacture Year</td>
                            <td>:</td>
                            <td>{{ vehicleData.manufacture_year }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-5 col-12 Aligner">
                      <img :src="vehicleData.bullet" v-if="vehicleData.bullet" style="height: auto; width: 500px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal" v-if="showExcelModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showExcelModal = false">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class="modal-container" @click.stop>
                <div class="modal-header" style="justify-content: flex-end">
                  <button type="button" class="close" @click="showExcelModal = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <h4>Please Select Filter To Generate the Excel Report</h4>

                  <!-- <p class="mt-2 mb-2" style="color: red">{{ error }}</p> -->
                  <p class="mt-2 mb-2" style="color: red">*is a required field</p>

                  <!-- <flat-pickr v-model="range" :config="rangeConfig" :placeholder="!isIEMode ? 'Select Date' : null" /> -->
                  <div class="d-flex align-items-center">
                    <div class="col-md-3">
  <span><span style="color: red;">*</span> Date</span>
</div>
                    <div class="col-md-9">
                      <flat-pickr v-model="range" :config="rangeConfig" placeholder="Select Date" />
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="col-md-3">
                      <span>Status</span>
                    </div>
                    <div class="col-md-9">
                      <MultiSelect v-model="searchFilter.status" class="mt-1" :options="['ACTIVE', 'INACTIVE']" :multiple="false" :allow-empty="true" placeholder="Select Status"></MultiSelect>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-md-3 col-12">
                      <button type="button" @click="downloadExcel()" class="btn btn-success w-100">Download Excel</button>
                    </div>
                    <div class="col-md-3 col-12">
                      <button type="button" @click="showExcelModal = false" class="btn btn-danger w-100">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import MultiSelect from "vue-multiselect";
import moment from "moment";
import { apply } from "core-js/fn/reflect";

import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  data() {
    return {
      moment: moment,
      filterOpt: [
        {
          text: "QR Code",
          value: "qrcode",
        },
        {
          text: "Engine Number",
          value: "engine_no",
        },
        {
          text: "Serial Number",
          value: "serial",
        },
      ],
      filterOptChosen: {
        text: "QR Code",
        value: "qrcode",
      },
      filter: null,
      searchFilter: {
        searchBy: "qrcode",
        keyword: "",
        status: "",
        // page: 1,
        // limit: 15,
      },
      loading: false,
      vue_universal_table_qrcode: {
        fields: [
          {
            title: "QR Code",
            variable: "qrcode",
          },
          {
            title: "Serial Number",
            variable: "serial",
          },
          {
            title: "Engine Number",
            variable: "engine_no",
          },
          {
            title: "Status",
            variable: "status",
          },
          {
            title: "Active Date",
            variable: "active_date",
          },
          {
            title: "Created At",
            variable: "created_at",
          },
        ],
        buttons: [
          {
            title: "Details",
            variable: "qrcode",
            class: "btn-outline-primary fa fa-link",
          },
        ],
        update: 0,
        dataTable: [],
      },
      range: "",
      vehicleData: null,
      showModal: false,
      showExcelModal: false,
      error: "",
      rangeConfig: {
        mode: "range",
        altInput: true,
        animate: !this.isRTL(),
      },
    };
  },
  components: {
    MultiSelect,
    flatPickr,
  },
  // mounted () {

  // },
  computed: {
    isDataAvailable() {
      return this.vue_universal_table_qrcode.dataTable && this.vue_universal_table_qrcode.dataTable.length > 0;
    },
  },
  watch: {
    filterOptChosen: {
      handler() {
        this.searchFilter.searchBy = this.filterOptChosen.value;
      },
      deep: true,
    },
  },
  methods: {
    showDetail(qrcode) {
      let url = "/api/reports/qr-code/detail/" + qrcode.replace(/"/g, "");
      console.log(url);
      this.vehicleData = null;
      this.$http
        .get(url)
        .then((resp) => {
          let listOfSeriesImage = [
            {
              name: "Genio",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/25183.jpg",
            },
            {
              name: "BeAT",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/63228.jpg",
            },
            {
              name: "Monkey",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/89252.png",
            },
            {
              name: "Scoopy",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/25324.png",
            },
            {
              name: "PCX 150",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/88723.png",
            },
            {
              name: "ADV 150",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/48889.jpg",
            },
            {
              name: "SHX150i",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/39999.png",
            },
            {
              name: "Forza",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/83922.png",
            },
            {
              name: "CRF150L",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/79470.png",
            },
            {
              name: "Revo X",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/67412.png",
            },
            {
              name: "Supra X",
              bullet: "https://cdnhonda.azureedge.net/uploads/products/43165.png",
            },
            {
              name: "Vario",
              bullet: "/img/Vehicle/Vario.png",
            },
          ];
          this.vehicleData = resp.data.data[0];
          for (var i = 0; i < listOfSeriesImage.length; i++) {
            if (this.vehicleData.series != null && this.vehicleData.series.toLowerCase() == listOfSeriesImage[i].name.toLowerCase()) {
              this.vehicleData.bullet = listOfSeriesImage[i].bullet;
            }
          }

          this.showModal = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async downloadExcel(filter) {
      if (this.range == "") {
        this.error = "Please Select Time Range To Download The Excel";
        return;
      }

      let url = "/api/reports/qr-code/download-excel" + (await this.initialiseFilter());

      this.$http
        .get(url)
        .then((resp) => {
          if (resp.data && resp.data.status === "success") {
            Swal.fire({
              // title: "Success!",
              html: `
                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 24 24">
                  <g fill="none" stroke="#2FBF56" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <path d="m7 12.5l3 3l7-7"/>
                    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"/>
                  </g>
                </svg>
                <h1 style="margin-top: 1rem;">Request Submitted</h1>
                <p>QR Code request has been<br>successfully submitted</p>
              `,
              showCancelButton: true,
              confirmButtonText: "       OK         ",
              cancelButtonText: "Go to Download Page",
              cancelButtonColor: "#f36f21",
              customClass: {
                confirmButton: "swal-custom-ok-button",
                cancelButton: "swal-custom-download-button",
              },
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                window.location.href = "/report/report-download";
              }
            });

            this.showExcelModal = false;
          } else {
            throw new Error(resp.data.message || "Unknown error occurred");
          }
        })
        .catch((err) => {
          console.error("Download request failed:", err);

          // Show error message
          this.$swal.fire({
            title: "Error!",
            text: "Failed to add the report request. Please try again.",
            icon: "error",
          });
        });
    },
    initialiseFilter() {
      let queryArray = [];

      // Ensure `this.filter` is a valid object
      if (this.filter && typeof this.filter === "object") {
        Object.keys(this.filter).forEach((key) => {
          let value = this.filter[key];

          // If the value is empty/null, just append the key without `=`
          if (!value || value.length === 0 || value === "All") {
            queryArray.push(key);
          } else {
            queryArray.push(`${key}=${encodeURIComponent(value)}`);
          }
        });
      } else {
        console.warn("Filter is invalid or null, skipping filters.");
      }

      // Ensure `this.range` is valid
      if (this.range) {
        let splitDateRange = this.range.split(" to ");
        if (splitDateRange.length === 2) {
          queryArray.push(`start=${splitDateRange[0]}`);
          queryArray.push(`end=${splitDateRange[1]}`);
        } else {
          console.warn("Invalid date range format:", this.range);
        }
      }

      let finalQuery = queryArray.length ? "?" + queryArray.join("&") : "";
      console.log("Final URL query:", finalQuery);
      return finalQuery;
    },

    handleDataLoaded(data) {
      this.loading = false;
      if (Array.isArray(data)) {
        this.$set(this.vue_universal_table_qrcode, "dataTable", data);
      } else {
        this.$set(this.vue_universal_table_qrcode, "dataTable", []);
      }
    },
    applySearch() {
      this.loading = true;
      this.filter = { ...this.searchFilter };
      this.vue_universal_table_qrcode.update++;

      // console.log(this.filter);
      // console.log(this.vue_universal_table_qrcode.dataTable);
    },
    // generateData () {
    //   var data = []

    //   for(var i = 0; i < 100; i++) {
    //     var createdAtDate = this.randomDate(new Date(2012, 0, 1), new Date(2017, 0, 1))
    //     var activeAtDate = this.randomDate(createdAtDate, new Date()).toISOString();
    //     createdAtDate = createdAtDate.toISOString();
    //     data.push({
    //       code : this.randomInt(0,100000000000),
    //       serial_number : this.randomInt(0,100000000000),
    //       engine_number : this.randomInt(0,100000000000),
    //       status : (this.randomInt(0,10)%2 == 1) ? 'ACTIVE' : 'INACTIVE',
    //       active_date : activeAtDate.split("T")[0] + " " + activeAtDate.slice(11,19),
    //       created_at : createdAtDate.split("T")[0] + " " + createdAtDate.slice(11,19)
    //     })
    //   }

    //   this.data = data;
    // }
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}
/* MODAL ENDS */
</style>

